module.exports = __webpack_public_path__ + "static/104_001-89c1a593a0cb311573dbcf55215dc281.jpg";